import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { merge } from '@backmarket/utils/object/merge'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'
import type { Location } from '@ds/types/Location'

/**
 * This composable is in charge of injecting the locale in the "param" property
 * if the given Location allows it.
 */
export function useRouteLocationWithLocale() {
  const i18n = useI18n()

  return (link: Location, overrideLocale?: Bcp47Locale): Location => {
    if (typeof link === 'string') {
      return link
    }

    if ('type' in link && link.type === 'external') {
      return link
    }

    return merge({}, link, {
      params: {
        locale: overrideLocale ?? toBcp47Locale(i18n.currentLocale),
      },
    })
  }
}
